import React from "react";
import styles from "./RegisterStepsNew.module.scss";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const ball = {
  hidden: {
    backgroundColor: "#edf0f7",
    scale: 0,
  },
  visibleActive: {
    backgroundColor: "#234ba2",
    scale: 1,
  },
  visible: {
    backgroundColor: "#edf0f7",
    border: "1px solid #d5d5d5",
    opacity: 0.64,
    scale: 1,
  },
};

interface RegisterStepsNewProps {
  stepCount: number;
}

const RegisterStepsNew: React.FC<RegisterStepsNewProps> = ({ stepCount }) => {
  const navigate = useNavigate();

  const handleStepClick = (step: number) => {
    if (stepCount >= step) {
      switch (step) {
        case 1:
          navigate("/select-type");
          break;
        case 2:
          navigate("/register-form");
          break;
        case 3:
          navigate("/work-zones-new");
          break;
        case 4:
          navigate("/resumen");
          break;
        default:
          break;
      }
    }
  };

  return (
    <motion.div
      className={styles.container}
      transition={{ ease: "easeInOut", duration: 0.3, delay: 0.3 }}
      animate={{ opacity: [0, 1] }}
    >
      <div className={styles.stepsContainer}>
        <div className={styles.stepsProgress}>
          {/* Paso 1: Select Type */}
          <motion.div
            variants={ball}
            onClick={() => handleStepClick(1)}
            initial="hidden"
            style={{ cursor: stepCount > 1 ? "pointer" : "default" }}
            animate={stepCount >= 1 ? "visibleActive" : "visible"}
            className={`${styles.ball} ${stepCount >= 1 ? styles.active : ""}`}
          >
            <span>1</span>
          </motion.div>
          
          {/* Línea 1-2 */}
          <div className={`${styles.line} ${stepCount >= 2 ? styles.activeLine : ""}`} />
          
          {/* Paso 2: Register Form */}
          <motion.div
            variants={ball}
            initial="hidden"
            style={{ cursor: stepCount > 2 ? "pointer" : "default" }}
            onClick={() => handleStepClick(2)}
            animate={stepCount >= 2 ? "visibleActive" : "visible"}
            className={`${styles.ball} ${stepCount >= 2 ? styles.active : ""}`}
          >
            <span>2</span>
          </motion.div>
          
          {/* Línea 2-3 */}
          <div className={`${styles.line} ${stepCount >= 3 ? styles.activeLine : ""}`} />
          
          {/* Paso 3: Work Zones */}
          <motion.div
            variants={ball}
            initial="hidden"
            style={{ cursor: stepCount > 3 ? "pointer" : "default" }}
            onClick={() => handleStepClick(3)}
            animate={stepCount >= 3 ? "visibleActive" : "visible"}
            className={`${styles.ball} ${stepCount >= 3 ? styles.active : ""}`}
          >
            <span>3</span>
          </motion.div>
          
          {/* Línea 3-4 */}
          <div className={`${styles.line} ${stepCount >= 4 ? styles.activeLine : ""}`} />
          
          {/* Paso 4: Resumen */}
          <motion.div
            variants={ball}
            initial="hidden"
            style={{ cursor: stepCount > 4 ? "pointer" : "default" }}
            onClick={() => handleStepClick(4)}
            animate={stepCount >= 4 ? "visibleActive" : "visible"}
            className={`${styles.ball} ${stepCount >= 4 ? styles.active : ""}`}
          >
            <span>4</span>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default RegisterStepsNew;
